import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KlarTilGodkendelseViewModel } from '../../store/models';

@Injectable({
    providedIn: 'root'
})
export class SagerTilGodkendelseService {
    constructor(
        private http: HttpClient
    ) { }

    getSagerTilGodkendelseView() {
        const url = `[api]/V2SagKonklusion/KlarTilGodkendelseByUser/[userid]`;
        return this.http.get<KlarTilGodkendelseViewModel[]>(url);
    }
}
